/*
  custom.js
  Purpose: Add custom JavaScript to enhance or modify store behavior.

  Pagination/infinite-scroll integration:
  - PaginationComponent prototype is patched ONCE (no leak) to fire a
    `pagination:loaded` event after page navigation / filter / sort.
  - Endless-scroll dispatches `cn:endless-scroll:appended` natively from
    assets/collection-endless-scroll.js after every fetch.
  - Both signals trigger refreshReviewsOnNewProducts() — a no-op when no
    legacy ruk_rating_snippet elements exist (cards now render stars
    server-side from metafields).

  Earlier versions registered a per-pagination-component MutationObserver
  with subtree:true. On long collections (shop-all + infinite scroll on
  iOS Safari) those observers fired on every variant-picker / quick-view
  /  filter mutation, accumulating GC pressure until WebKit OOM-killed
  the page. Removed entirely — direct event listening is sufficient.
*/

(function () {
  'use strict';

  function patchPaginationComponent() {
    var Proto = window.PaginationComponent && window.PaginationComponent.prototype;
    if (!Proto || Proto.__cnPatched) return;

    var original = Proto.updateTargetsFromHTML;
    if (typeof original !== 'function') return;

    Proto.updateTargetsFromHTML = function (html) {
      original.call(this, html);
      var self = this;
      // Microtask delay so any DOM-update observers in caller settle first
      setTimeout(function () {
        document.dispatchEvent(
          new CustomEvent('pagination:loaded', {
            detail: { containerId: self.dataset && self.dataset.containerId }
          })
        );
      }, 100);
    };

    Proto.__cnPatched = true;
  }

  function refreshReviewsOnNewProducts() {
    // Only matches legacy widget containers — empty when cards use
    // server-rendered metafield stars (current state).
    var containers = document.querySelectorAll(
      '.ruk_rating_snippet:empty, .ruk_rating_snippet:not([data-loaded])'
    );
    if (containers.length === 0) return;
    if (typeof window.ratingSnippet !== 'function') return;

    window.ratingSnippet('ruk_rating_snippet', {
      store: 'bbc04c.myshopify.com',
      mode: 'default',
      color: '#FFBF1A',
      linebreak: false,
      text: 'Reviews',
      singularText: 'Review',
      lang: 'nl',
      usePolaris: true,
      showEmptyStars: false
    });
  }

  // Throttle: collapse multiple events fired in rapid succession (filter +
  // immediate scroll-append can stack) into one refresh call.
  var refreshTimer = null;
  function scheduleRefresh() {
    if (refreshTimer) return;
    refreshTimer = setTimeout(function () {
      refreshTimer = null;
      refreshReviewsOnNewProducts();
    }, 300);
  }

  /**
   * Remove EMPTY Rebuy/Fast-Bundle placeholder divs
   * (`[id^="rbr-container-element"]`).
   *
   * Both Rebuy and Fast Bundle (FBP) use this id prefix. Originally
   * this pruned ALL of them unconditionally, which was wrong: Fast
   * Bundle ALSO injects its actual bundle widget under the same id
   * (e.g. `#rbr-container-element-addOn`) and gets killed by our
   * MutationObserver, causing the widget to flicker and disappear
   * (production incident, GDC product).
   *
   * Now: only remove placeholders that are truly empty / contain no
   * visible content. A widget Fast Bundle has actually populated has
   * real child elements with visible boxes — we leave those alone.
   *
   * A MutationObserver catches late injections.
   */
  function isPlaceholderEmpty(node) {
    if (!node) return true;
    // Has no element children → empty placeholder
    if (node.childElementCount === 0) return true;
    // Has children but they take up no layout space → still empty
    var rect = node.getBoundingClientRect();
    if (rect.width === 0 && rect.height === 0) return false; // not yet rendered, leave alone
    // If any descendant has visible dimensions, the widget rendered — keep it
    var descendants = node.querySelectorAll('*');
    for (var i = 0; i < descendants.length; i++) {
      var r = descendants[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0) return false;
    }
    return true;
  }

  function pruneRebuyPlaceholders() {
    var nodes = document.querySelectorAll('[id^="rbr-container-element"]');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (isPlaceholderEmpty(n) && n.parentNode) {
        n.parentNode.removeChild(n);
      }
    }
  }

  function observeRebuyInjections() {
    if (!('MutationObserver' in window)) return;
    var mo = new MutationObserver(function () {
      if (document.querySelector('[id^="rbr-container-element"]')) {
        pruneRebuyPlaceholders();
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    patchPaginationComponent();
    document.addEventListener('pagination:loaded', scheduleRefresh);
    document.addEventListener('cn:endless-scroll:appended', scheduleRefresh);
    // Rebuy placeholder pruning DISABLED:
    // Fast Bundle uses the same id prefix and injects its container
    // empty, then populates it asynchronously. Any pruning here races
    // against FB's population and intermittently deletes the bundle
    // widget on slower browsers (incident 2026-05-11). Leaving the
    // placeholders alone is the least-bad option — empty Rebuy
    // placeholders reserve a few px of layout space; that's vastly
    // better than killing the entire Fast Bundle widget mid-render.
    // pruneRebuyPlaceholders();
    // observeRebuyInjections();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
